import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";


// flatpickr
import "flatpickr/dist/themes/material_blue.css";
import FlatPickr from "react-flatpickr";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import SearchStudent from "./partials/SearchStudent";

import ImportStudentModal from "./partials/ImportStudentModal";

import {
    getStudents as onGetStudents,
    addNewStudent as onAddNewStudent,
    updateStudent as onUpdateStudent,
    deleteStudent as onDeleteStudent,
} from "store/actions";

//import { onGetStudents } from "../../store/students/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,Collapse,
} from "reactstrap";



//import { Card, CardBody, Col, Modal, ModalBody, ModalHeader, Row, Label, Input, Form, Collapse, FormFeedback } from 'reactstrap';

import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const Student = () => {

    //meta title
    document.title = "Étudiants | CinzanEdu";

   

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [student, setStudent] = useState(null);

    const [modalOpen, setModalOpen] = useState(false);


    const dateChange = (date) => {
        setSelectDate(date);
    };
    const [isOpen, setIsOpen] = useState(false);
    //const toggle = () => setIsOpen(!isOpen);
    const experienceData = [];
    const jobType = [];

    


 

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            uuid: (student && student.uuid) || '',
            first_name: (student && student.first_name) || '',
            last_name: (student && student.last_name) || '',
            sex: (student && student.sex) || '',
            matricule: (student && student.matricule) || '',
           
            father_firstname: (student && student.father_firstname) || '',
            mother_firstname: (student && student.mother_firstname) || '',
            mother_lastname: (student && student.mother_lastname) || '',
            tutor_name: (student && student.tutor_name) || '',
            tutor_phone: (student && student.tutor_phone) || '',
            family_situation: (student && student.family_situation) || '',
            birthdate: (student && student.birthdate) || '',
            birthplace: (student && student.birthplace) || '',
            phone: (student && student.phone) || '',
            residence_place: (student && student.residence_place) || '',
           
            
        },
        validationSchema: Yup.object({
           
            first_name: Yup.string().required("Veuillez saisir le prénom"),
            last_name: Yup.string().required("Veuillez saisir le nom"),
            civility: Yup.string().required("Veuillez saisir la civilité"),
            matricule: Yup.string().required("Veuillez saisir le matricule"),
            nationality: Yup.string().required("Veuillez saisir la nationalité"),
            phone: Yup.string().required("Veuillez saisir le téléphone"),
            
  
        }),
        onSubmit: (values) => {
            if (isEdit) {
                //const payload = { series_category: values }
                const updateStudent = {
                    id: values.id,
                    uuid: values.uuid,
                    first_name: values.first_name,
                    last_name: values.last_name,
                    sex: values.sex,
                    matricule: values.matricule,
                    usttb_id: values.usttb_id,
                    father_firstname: values.father_firstname,
                    mother_firstname: values.mother_firstname,
                    mother_lastname: values.mother_lastname,
                    tutor_name: values.tutor_name,
                    tutor_phone: values.tutor_phone,
                    family_situation: values.family_situation,
                    birthdate: values.birthdate,
                    birthplace: values.birthplace,
                    phone: values.phone,
                    residence_place: values.residence_place,
                    residence_status: values.residence_status,
                    
                    
                };
                // update movie category
                dispatch(onUpdateStudent(updateStudent));
                validation.resetForm();
            } else {
                const newStudent = {
                    //id: values["id"],
                    //uid: values["uid"],
                    first_name: values["first_name"],
                    last_name: values["last_name"],
                    sex: values["sex"],
                    matricule: values["matricule"],
                    usttb_id: values["usttb_id"],
                    father_firstname: values["father_firstname"],
                    mother_firstname: values["mother_firstname"],
                    mother_lastname: values["mother_lastname"],
                    tutor_name: values["tutor_name"],
                    tutor_phone: values["tutor_phone"],
                    family_situation: values["family_situation"],
                    birthdate: values["birthdate"],
                    birthplace: values["birthplace"],
                    phone: values["phone"],
                    residence_place: values["residence_place"],
                    residence_status: values["residence_status"],
                   
                   
                };
                // save new movie category
                dispatch(onAddNewStudent(newStudent));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    const StudentProperties = createSelector(
        (state) => state.studentReducer, 
        (studentReducer) => ({
            students: studentReducer.students,
            loading: studentReducer.loading
        })
    );

    const {students, loading} = useSelector(StudentProperties);

    const [isLoading, setLoading] = useState(loading)


    /*
    useEffect(() => {
        if (students && !students.length) {
            dispatch(onGetStudents({}));
        }
    }, [dispatch, students.length]);

    */

    // Fetch initial une seule fois au montage
    useEffect(() => {
        dispatch(onGetStudents()); // fetch initial complet
    }, [dispatch]);


    

    const toggle = () => {
        if (modal) {
            setModal(false);
            setStudent(null);
        } else {
            setModal(true);
        }
    };

    const handleStudentClick = arg => {
        const student = arg;
        setStudent({
            id: student.id,
            uuid: student.uuid,
            first_name: student.first_name,
            last_name: student.last_name,
            civility: student.civility,
            matricule: student.matricule,
            phone: student.phone,
            
           
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (student) => {
        setStudent(student);
        setDeleteModal(true);
    };

    const handleDeleteStudent = () => {
        if (student && student.id) {
            
            dispatch(onDeleteStudent(student));
            setDeleteModal(false);
        }
    };

    /*
    const onClickNewStudent = () => {
        setIsEdit(false);
        setStudent(null);
        toggle();
       
    };
    */


    // Search
    const handleSearch = (filters) => {
        dispatch(onGetStudents(filters));
    };

    // Add new student
    /*const onClickNewStudent = () => {
        console.log("NAVIGATE");
       navigate("/student-create")
       
    };*/

    const handleSuccess = (data) => {
        console.log("Import réussi :", data);
        // ici tu peux recharger la liste des facultés si besoin
    };

    

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Numéro étudiant",
                accessorKey: "student_number",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Prénom",
                accessorKey: "first_name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Nom",
                accessorKey: "last_name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Genre",
                accessorKey: "sex",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Téléphone",
                accessorKey: "phone",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">

                            <li>
                                <Link 
                                    //to="/student-details"
                                    to={`/student/${cellProps.row.original.uuid}/details`}
                                    className="btn btn-sm btn-soft-primary" 
                                    //onClick={() => dispatch(onSetSelectedStudent(cellProps.row.original))}
                                    id={`viewtooltip${cellProps.row.original.id}`}>

                                <i className="mdi mdi-eye-outline" />
                                <UncontrolledTooltip placement="top" target={`viewtooltip${cellProps.row.original.id}`}>
                                    Apperçu
                                </UncontrolledTooltip>
                                </Link>
                            </li>
                            
                            
                            <li>
                                <Link
                                    to={`/student/${cellProps.row.original.uuid}/edit`}
                                    className="btn btn-sm btn-soft-info"
                                    
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteStudent}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Étudiants" breadcrumbItem="Liste des étudiants" />

                    <SearchStudent onSearch={handleSearch} />

                    
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                               <div className="d-flex gap-2">
                                                    <Button color="success" onClick={() => setModalOpen(true)}>
                                                        Importer un fichier
                                                    </Button>


                                                    <Link to="/student/new"  className="btn btn-primary me-1">Ajouter un étudiant</Link> 
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={students || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={false}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                   
                </div>
            </div>
            <ToastContainer />

            <ImportStudentModal
                isOpen={modalOpen}
                toggle={() => setModalOpen(!modalOpen)}
                onSuccess={handleSuccess}
            />
        </React.Fragment>
    );
}


export default Student;